var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2673",
    "data-name": "Group 2673",
    transform: "translate(-207 -397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1262",
    "data-name": "Rectangle 1262",
    width: 25,
    height: 25,
    transform: "translate(207 397)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1914",
    "data-name": "Group 1914",
    transform: "translate(210.247 401.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M325.512,202.935V205.9a1.978,1.978,0,0,1-1.978,1.978h-8.651a1.978,1.978,0,0,1-1.978-1.978v-8.652a1.978,1.978,0,0,1,1.978-1.978h7.29c.18-.043.353-.08.513-.11l-.268-.986h-7.535a3.077,3.077,0,0,0-3.072,3.072v8.652a3.077,3.077,0,0,0,3.072,3.072h8.652a3.076,3.076,0,0,0,3.072-3.072v-3.726Z",
    transform: "translate(-311.811 -193.048)",
    fill: "#15355c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M345.014,188.847c-.13-.475.093-.632.5-.35l6.362,4.443a.379.379,0,0,1,0,.664l-6.362,4.443c-.4.282-.626.125-.5-.35l.764-2.81a7.348,7.348,0,0,0-7.131,4.733c-.482-8.2,7.064-8.2,7.064-8.2Z",
    transform: "translate(-333.441 -188.357)",
    fill: "#15355c"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/shareicon.7a10c92a0c37a57bb34bfbc713ff32a5.svg";
export { ForwardRef as ReactComponent };